import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ShiftItem from "../components/shift/ShiftItem";
import { getColumnValue } from "shared/util/datagrid";

import { StoreContext } from "shared/context/store-context";
import Layout from "./shared/Layout";
import { days, days_en } from "shared/util/types";
import "./Admin.css";
import { getCurrentLanguage } from "shared/utility/lang";

const Shifts = () => {
  const { t } = useTranslation();
  const language = getCurrentLanguage();

  const { shifts, schoolOptions, DeleteShift, InsertShift, UpdateShift } = useContext(StoreContext);
  const itemType = "shift";
  const listName = "main_shifts";

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     UpdateShifts();
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, [UpdateShifts]);

  const standardHelpItems = [
    t("shiftAnalyzer.help1"),
    t("shiftAnalyzer.help2"),
    t("shiftAnalyzer.help3"),
    t("shiftAnalyzer.help4"),
    t("shiftAnalyzer.help5"),
  ];

  const highlightedHelpItems = [
    t("shiftAnalyzer.highlightedHelp1"),
    t("shiftAnalyzer.highlightedHelp2"),
    t("shiftAnalyzer.highlightedHelp3"),
    t("shiftAnalyzer.highlightedHelp4"),
    t("shiftAnalyzer.highlightedHelp5"),
  ];

  let listColumns = [];

  if (schoolOptions?.length > 1) {
    listColumns.push(getColumnValue("school", t("client"), schoolOptions, "school", 300));
  }

  listColumns.push({
    field: "day",
    headerName: t("day"),
    width: 200,
    valueGetter: (params) => {
      try {
        const dayList = language === "en" ? days_en : days;
        return dayList.find((day) => day.value.toString() === params.row.day.toString()).label;
      } catch (e) {
        return "";
      }
    },
  });

  listColumns.push({ field: "name", headerName: t("name"), width: 250 });
  listColumns.push({ field: "description", headerName: t("description"), width: 300 });
  listColumns.push({
    field: "numberofpersonel",
    headerName: t("numberofpassengers"),
    width: 200,
    color: "red",
    valueGetter: (params) => {
      try {
        return params?.row?.users?.length?.toString() || "0";
      } catch (e) {
        return t("shiftAnalyzer.error");
      }
    },
  });

  listColumns.push({ field: "serviceArrivalTime", headerName: t("shiftServiceArrivalTime"), width: 350 });
  listColumns.push({ field: "serviceLeaveTime", headerName: t("shiftServiceLeaveTime"), width: 350 });

  return (
    <React.Fragment>
      <Layout
        itemType={itemType}
        items={shifts}
        listName={listName}
        listColumns={listColumns}
        SelectedItemComponent={ShiftItem}
        NewItemComponent={ShiftItem}
        DeleteItem={DeleteShift}
        InsertItem={InsertShift}
        UpdateItem={UpdateShift}
        standardHelpItems={standardHelpItems}
        highlightedHelpItems={highlightedHelpItems}
      />
    </React.Fragment>
  );
};

export default Shifts;
